import { useRouteLoaderData } from 'react-router';
import type { loader as rootLoader } from '../../root';

export function useRootLoaderData() {
  const loaderData = useRouteLoaderData<typeof rootLoader>('root');

  if (!loaderData) {
    throw new Error('Root Loader Data is missing!');
  }

  return loaderData;
}